<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import TitleHeader from '@/molecules/TitleHeader.vue';
import BaseLabel from '@/atoms/BaseLabel.vue';
import BaseButton from '@/atoms/BaseButton.vue';
import { updateFlowData } from '@/parcours/stores/flowStore';
import { BodyPartKey, tmsBodyPartsConfig } from '@/parcours/flows/tms/tmsBodyParts.config';

defineEmits(['back', 'next', 'submit', 'canSubmit']);

const route = useRoute();
const router = useRouter();

const bodyPart = computed(() => route.query.symptom as BodyPartKey);
const syndromeField = computed(() => route.query.syndrome as string);

const syndrome = computed(() =>
  tmsBodyPartsConfig[bodyPart.value]?.syndromes.find((s) => s.field === syndromeField.value),
);

function answer(value: 'PROVEN' | 'NONEXISTENT') {
  updateFlowData({ [syndromeField.value]: value });
  router.back();
}
</script>

<template>
  <div>
    <TitleHeader :on-back="() => router.back()" :title="syndrome?.label || '-'" />

    <BaseLabel class="mt-4 px-1" preset="medium" :text="syndrome?.question" />

    <div class="mt-8 space-y-2">
      <BaseButton
        class="w-full"
        label="Oui"
        type="primary"
        :on-click="() => answer('PROVEN')"
      />
      <BaseButton
        class="w-full"
        label="Non"
        type="secondary"
        :on-click="() => answer('NONEXISTENT')"
      />
    </div>
  </div>
</template>
